import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { InputText, Modal, DataGrid } from "src/components";
import { Grid, Button, Box, Typography, Divider } from "@material-ui/core";
import NumberFormat from "react-number-format";
import {
  AttachMoney as CashbackIcon,
  MoneyOff as PresenteIcon,
  ArrowUpward as RecebeuIcon,
  ArrowDownward as PagouIcon,
  Cancel as CancelIcon,
} from "@material-ui/icons";

import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
import { carregarClienteExtrato } from "src/store/actions/clientes";

dayjs.extend(utc);

function EmpresaClienteExtrato({ open, close, cliente_id }) {
  const { extrato, loading } = useSelector((state) => state.clientes);
  const dispatch = useDispatch();

  useEffect(() => {
    open && dispatch([carregarClienteExtrato(cliente_id)]);
  }, [open]);

  // 'mv.numero_venda'
  return (
    <Modal open={open} width={750} height={500}>
      <Box>
        <Typography>Extrato</Typography>
        <PerfectScrollbar>
          <DataGrid
            style={{}}
            // isLoading={loading}
            columns={[
              { title: "ID", field: "movimento_id" },
              {
                title: "R/E",
                render: (data) =>
                  data.tipo === "R" ? (
                    <PagouIcon style={{ color: "red" }} />
                  ) : (
                    <RecebeuIcon style={{ color: "green" }} />
                  ),
                width: 30,
                headerStyle: {},
                cellStyle: {},
              },
              {
                title: "Tipo",
                render: (data) =>
                  data.tipo_cashback == "CASH" ? (
                    <CashbackIcon style={{ color: "blue" }} />
                  ) : (
                    <PresenteIcon style={{ color: "green" }} />
                  ),
                width: 30,
                headerStyle: {},
                cellStyle: {},
              },
              {
                title: "Emissão",
                render: (data) => dayjs(data.data_emissao).format("DD/MM/YYYY"),
                width: 30,
                headerStyle: { paddingLeft: 10 },
                cellStyle: { paddingLeft: 10 },
              },
              {
                title: "Vencimento",
                render: (data) => dayjs(data.vencimento).format("DD/MM/YYYY"),
              },
              {
                title: "R$.Valor",
                render: (data) => (
                  <NumberFormat
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"R$ "}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    displayType={"text"}
                    value={data.valor || 0}
                  />
                ),
                cellStyle: { textAlign: "right" },
              },
            ]}
            data={extrato}
            options={{
              maxBodyHeight: 400,
              minBodyHeight: 400,
            }}
          />
        </PerfectScrollbar>
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          <Button color="secondary" size="small" onClick={() => close()}>
            {<CancelIcon />}&nbsp;Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default EmpresaClienteExtrato;
